import Amount from '@/types/Amount';

export default class Payment {
	public paymentId: string;
	public payingId: string;
	public paymentMethod: Map<string, string>;
	public paymentDescription: Map<string, string>;
	public cost: Amount;
}
